import React from 'react'
import type { CosmicProductType } from '@/lib/cms/cosmic/types/CosmicProductType'

export const FdaStatementSection = (product: CosmicProductType) => {
  const { FDAcontent } = product?.fdaDisclaimers?.[0] ?? {}
  if (!FDAcontent) return null
  return (
    <div
      className="flex w-full items-center justify-center bg-[#5A8FC34D] px-6 py-4 text-center"
      data-test="product-key-ingredients-section"
    >
      <span
        className="text-sm"
        dangerouslySetInnerHTML={{ __html: FDAcontent }}
      />
    </div>
  )
}
